import { render, staticRenderFns } from "./UploadData.vue?vue&type=template&id=04017e4c&scoped=true&"
import script from "./UploadData.vue?vue&type=script&lang=tsx&"
export * from "./UploadData.vue?vue&type=script&lang=tsx&"
import style0 from "./UploadData.vue?vue&type=style&index=0&id=04017e4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04017e4c",
  null
  
)

export default component.exports